import React from 'react';
export function AdultFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-12" data-id="element-531">
      Frequently Asked Questions
    </h2>;
}